import type { FunctionComponent } from 'react';

import { DocsLink } from '../../../generic/Link';
import type { JiraComponent } from '../../../../../shared/jira';

import JiraComponents from './Components';
import JiraSettingsSection from './JiraSettingsSection';

export type JiraSettingsComponentsProps = {
  components: JiraComponent[];
  onUpdateComponents: (components: JiraComponent[]) => void;
};

/**
 * Table for managing the Jira Components for this Jira instance.
 */
const JiraSettingsComponents: FunctionComponent<JiraSettingsComponentsProps> = ({
  components,
  onUpdateComponents,
}) => (
  <JiraSettingsSection
    heading="Components"
    subHeading={
      <>
        Jira components available to apply to exported issues.
        {' '}
        Component IDs can be found in the JSON response at {'<'}SITE-URL{'>'}/rest/api/2/project/{'<'}PROJECT-ID{'>'}/components.
        {' '}
        <DocsLink to="atlassian-jira">
          Please read our docs for more info.
        </DocsLink>
      </>
    }
  >
    <JiraComponents
      components={components}
      isDisabled={false}
      onChange={onUpdateComponents}
    />
  </JiraSettingsSection>
);

export default JiraSettingsComponents;
